import { core_v1_Rule } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import Spacer from '@antimatterhq/ui/components/spacer';

interface MitreInformationReviewProps {
  rule: core_v1_Rule;
}

export function MitreInformationReview({ rule }: MitreInformationReviewProps) {
  const mitre = rule.spec.metadata?.mitre || [];
  const hasMitre = mitre.length > 0 && mitre[0].taxonomy;

  return (
    <div>
      {hasMitre &&
        mitre.map((item, index) => (
          <div key={index}>
            {index > 0 && <Spacer size="lg" />}

            <Fieldset.Field>
              <Fieldset.Label>Taxonomy:</Fieldset.Label>
              <Fieldset.Value>{item.taxonomy}</Fieldset.Value>
            </Fieldset.Field>

            <Spacer size="sm" />

            <Fieldset.Field>
              <Fieldset.Label>Tactic:</Fieldset.Label>
              <Fieldset.Value>
                {item.tactic || <span className="italic">[none]</span>}
              </Fieldset.Value>
            </Fieldset.Field>

            <Spacer size="sm" />

            <Fieldset.Field>
              <Fieldset.Label>Technique:</Fieldset.Label>
              <Fieldset.Value>
                {item.technique || <span className="italic">[none]</span>}
              </Fieldset.Value>
            </Fieldset.Field>

            <Spacer size="sm" />

            <Fieldset.Field>
              <Fieldset.Label>TechniqueID:</Fieldset.Label>
              <Fieldset.Value>
                {item.techniqueId || <span className="italic">[none]</span>}
              </Fieldset.Value>
            </Fieldset.Field>

            <Spacer size="sm" />

            <Fieldset.Field>
              <Fieldset.Label>Sub-technique:</Fieldset.Label>
              <Fieldset.Value>
                {item.subTechnique || <span className="italic">[none]</span>}
              </Fieldset.Value>
            </Fieldset.Field>

            <Spacer size="sm" />

            <Fieldset.Field>
              <Fieldset.Label>Sub-techniqueID:</Fieldset.Label>
              <Fieldset.Value>
                {item.subTechniqueId || <span className="italic">[none]</span>}
              </Fieldset.Value>
            </Fieldset.Field>
          </div>
        ))}

      {!hasMitre && (
        <Fieldset.Field>
          <Fieldset.Value>
            <span className="italic">
              No MITRE ATT&CK information configured
            </span>
          </Fieldset.Value>
        </Fieldset.Field>
      )}
    </div>
  );
}
